// Единая логика статусов направления (N-017), см. admin-panel/src/utils/referralStatus.js.
export function referralLabel(status, clinicConfirmedAt) {
  if (status === 'primary_done') return 'Дошёл';
  if (status === 'duplicate') return 'Дубль';
  if (status === 'timed_out') return 'Не дошёл';
  if (status === 'inactive') return 'Неактивно';
  if (status === 'active') return clinicConfirmedAt ? 'Подтверждён' : 'Направлен';
  return status;
}

export const REFERRAL_STATUS_OPTIONS = [
  ['', 'Все статусы'],
  ['active', 'Направлен / Подтверждён'],
  ['primary_done', 'Дошёл'],
  ['duplicate', 'Дубль'],
  ['timed_out', 'Не дошёл'],
  ['inactive', 'Неактивно'],
];

export const REFERRAL_STATUS_DEFS = [
  ['Направлен', 'Врач добавил пациента и привязал к вам. Ждём ближайшей ночной проверки (данные обновляются не мгновенно).'],
  ['Подтверждён', 'Проверка прошла, оплат до даты привязки не было — направление действует, ждём первой оплаты (до 30 дней).'],
  ['Дубль', 'У пациента была оплата у вас ДО даты привязки — он уже был вашим клиентом, комиссия по нему не начисляется.'],
  ['Дошёл', 'Пациент оплатил первый визит — дальше считаются повторные визиты.'],
  ['Не дошёл', 'Пациент не оплатил ни разу за 30 дней с момента привязки — направление снято.'],
];
